import React from 'react'

export default function SignUp() {
  return (
    <div id='green-div'>
        <h4>We believe in a culture of curiosity, open communication, and relentless improvement everyone's ideas matter, and each challenge is an opportunity to grow.</h4>
    </div>
  )
}
